<template>
  <div style="padding: 20px; border: 1px solid #ccc; max-width: 400px; margin: 50px auto;">
    <h2>HKT 登录测试 (两步验证)</h2>
    
    <div v-if="!isCodeSent">
      <div class="input-group">
        <label>用户名：</label>
        <input v-model="formData.username" type="text" />
      </div>
      <div class="input-group">
        <label>密码：</label>
        <input v-model="formData.password" type="password" />
      </div>
      <div class="input-group">
        <label>手机号：</label>
        <input v-model="formData.phone" type="text" />
      </div>
    </div>

    <div v-else>
      <p style="color: green;">✓ 基本信息已发送，请查看手机验证码</p>
      <div class="input-group">
        <label>验证码：</label>
        <input v-model="formData.code" type="text" placeholder="请输入验证码" />
      </div>
    </div>

    <button @click="handleAction" style="margin-top: 20px; width: 100%; height: 40px;">
      {{ isCodeSent ? '提交验证码并登录' : '获取验证码' }}
    </button>

    <pre style="background: #eee; margin-top: 20px; padding: 10px; font-size: 12px;">
      当前数据：{{ formData }}
    </pre>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TestLogin',
  data() {
    return {
      isCodeSent: false, // 是否已进入第二步
      formData: {
        username: '',
        password: '',
        phone: '',
        code: ''
      }
    };
  },
  methods: {
    async handleAction() {
      // 1. 准备请求参数
      const params = new URLSearchParams();
      
      if (!this.isCodeSent) {
        // --- 第一次点击逻辑 ---
        if (!this.formData.username || !this.formData.password) return alert('请填全信息');
        
        params.append('username', this.formData.username);
        params.append('password', this.formData.password);
        params.append('phone', this.formData.phone);
      } else {
        // --- 第二次点击逻辑 ---
        if (!this.formData.code) return alert('请输入验证码');
        
        params.append('username', this.formData.username);
        params.append('password', this.formData.password);
        params.append('phone', this.formData.phone);
        params.append('code', this.formData.code);
      }

      try {
        console.log('正在发送数据...', Object.fromEntries(params));
        
        // 注意：这里由于是在本地，可能会报 CORS 跨域错误
        const res = await axios.post('/api/verify.php', params);
        
        console.log('服务器返回：', res.data);

        if (!this.isCodeSent) {
          this.isCodeSent = true; // 切换到输入验证码状态
        } else {
          alert('登录流程完成！请看控制台返回数据');
        }
      } catch (err) {
        console.error('请求失败：', err);
        alert('接口请求失败，请按 F12 查看控制台 Console 的红字报错内容。如果是 CORS 报错，我们需要配置代理。');
      }
    }
  }
};
</script>

<style scoped>
.input-group { margin-bottom: 10px; }
.input-group label { display: inline-block; width: 70px; }
input { padding: 5px; width: 200px; }
</style>